// The Global Inventory Report guide (57_InventoryReport.jsx · ModuleHelp, Max 01/11).
const en = {
  weekT: 'Pick the day',
  weekB: 'The report shows one day at a time, normally a Friday. Choose it here; the refresh button reads the loads again.',
  tabsT: 'The five tabs',
  tabsB: 'Dashboard has the figures, Loads is where each source is loaded, then the stock layers, what is in transit, and the classification the filters read.',
  dashT: 'The Dashboard',
  dashB: 'On hand and amount per entity by the age of the stock, and the top SKUs. Use the SKU and class filters, which take several values, to narrow it.',
  exportT: 'Export the working file',
  exportB: 'Downloads this day as the Excel working file with its pivots. It appears once the day has at least one load.',
};
const ko = {
  weekT: '날짜 선택',
  weekB: '리포트는 하루씩, 보통 금요일 기준으로 표시됩니다. 여기서 날짜를 고르고, 새로고침 버튼으로 로드를 다시 읽습니다.',
  tabsT: '다섯 개의 탭',
  tabsB: 'Dashboard는 수치, Loads는 소스별 로드, 그다음 재고 레이어, 이동 중 물량, 필터가 읽는 분류입니다.',
  dashT: 'Dashboard',
  dashB: 'entity별 재고 수량과 금액을 재고 연령별로, 그리고 상위 SKU를 보여줍니다. 여러 값을 고를 수 있는 SKU·분류 필터로 범위를 좁히세요.',
  exportT: '작업 파일 내보내기',
  exportB: '해당 날짜를 pivot이 포함된 Excel 작업 파일로 내려받습니다. 그날 로드가 하나 이상 있을 때 나타납니다.',
};
const vi = {
  weekT: 'Chọn ngày',
  weekB: 'Báo cáo xem từng ngày một, thường là thứ Sáu. Chọn ngày ở đây; nút làm mới sẽ đọc lại các lần load.',
  tabsT: 'Năm tab',
  tabsB: 'Dashboard là các con số, Loads là nơi load từng nguồn, rồi đến các lớp tồn kho, hàng đang vận chuyển và phần phân loại mà bộ lọc dùng.',
  dashT: 'Dashboard',
  dashB: 'Số lượng và giá trị tồn theo entity và theo tuổi hàng, cùng các SKU lớn nhất. Dùng bộ lọc SKU và phân loại (chọn được nhiều giá trị) để thu hẹp.',
  exportT: 'Xuất file làm việc',
  exportB: 'Tải ngày này về dưới dạng file Excel làm việc có sẵn pivot. Nút chỉ hiện khi ngày đó đã có ít nhất một lần load.',
};
const zh = {
  weekT: '选择日期',
  weekB: '报表一次显示一天，通常是周五。在这里选择日期；刷新按钮会重新读取各次加载。',
  tabsT: '五个标签',
  tabsB: 'Dashboard 是数据，Loads 用来加载各个来源，其后是库存分层、在途货物，以及筛选器所用的分类。',
  dashT: 'Dashboard',
  dashB: '按库龄显示各 entity 的库存数量和金额，以及排名靠前的 SKU。可用支持多选的 SKU 和分类筛选器缩小范围。',
  exportT: '导出工作文件',
  exportB: '把这一天下载为带数据透视表的 Excel 工作文件。该日至少有一次加载后才会出现。',
};

const dictionary = { ns: 'tourInventory', en, ko, vi, zh };
export default dictionary;
